class FixMobileMenuAccessibility {
    constructor() {
        // Get all the elements with the class .wp-block-navigation-item in the header
        this.menuItems = document.querySelectorAll('header nav > ul > li.menu-item-has-children');
        this.events();
    }

    events() {
        // Add an event listener to each menu item
        for (var i = 0; i < this.menuItems.length; i++) {
            this.menuItems[i].addEventListener('click', this.toggleMenu.bind(this));
        }
    }

    toggleMenu(e) {
        // Get the current menu item
        var menuItem = e.currentTarget;
        
        // Check if any other menu items have the .open class
        for (const item of this.menuItems) {
            if (item !== menuItem && item.classList.contains('open') && ! item.contains(menuItem)) {
                // Remove the .open class from the other menu items
                item.classList.remove('open');
                
                const submenus = item.querySelectorAll('ul');
                for (const submenu of submenus) {
                    submenu.style.display = 'none';
                }
            }
        }
    }
}

export default FixMobileMenuAccessibility;

